import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: 'search'
})
export class SearchListPipes implements PipeTransform {
    constructor() {
    }
    transform(items: any[], searchText: string): any[] {
        if (!items || !searchText) {
            return items;
        }
        if (searchText) {
            return items.filter(val => 
                val['description'].toLowerCase().indexOf(searchText.toLowerCase()) >= 0);
        }
    }
}